'use client';
import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Conditional } from '@cat-ecom/pcc-components';
import { MANUAL_APPROVAL_MESSAGE } from 'constants/storageConstants';
import { ESPOT_MANUAL_APPROVAL_MESSAGE_VIEWED } from '../../_constants/constants';
import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';
import {
  getSessionStorage,
  setSessionStorage
} from '@cat-ecom/common/utils/storageUtils';
import { OutageMessageBanner } from './outage-message-banner';

const ManualApprovalMessage = ({
  dealerName
}: Readonly<{ dealerName: string }>) => {
  const t = useTranslations();
  // TODO - Input Validation - Ensure that the value here will be read as a boolean value
  // Add the type to the const: (const value: 'true' | 'false' = getSessionStorage(sessionValue)) 
  const isManualApprovalMessageViewed = getSessionStorage(
    MANUAL_APPROVAL_MESSAGE
  );
  const approvalMsg = t('2175_MANUAL_APPROVAL_REG_ESPOT');
  const welcomeMsg11 = replaceTokensInString(
    t('WELCOME_MESSAGE11', {
      0: dealerName
    })
  );
  const welcomeMsg10 = replaceTokensInString(
    t('WELCOME_MESSAGE10', {
      0: dealerName
    })
  );
  const heading = `${approvalMsg} ${welcomeMsg11} ${welcomeMsg10}`;
  useEffect(() => {
    if (!isManualApprovalMessageViewed) {
      // TODO - Input Validation - Ensure that the values being set here are string values
      // The current behavior os EPOT_MANUAL_APPROVAL_MESSAGE_VIEWED is that it is being set as 'viewed'
      // Instead of this, its recommended be converted into a boolean value
      setSessionStorage(
        MANUAL_APPROVAL_MESSAGE,
        ESPOT_MANUAL_APPROVAL_MESSAGE_VIEWED
      );
    }
  }, [isManualApprovalMessageViewed]);
  return (
    <Conditional test={!isManualApprovalMessageViewed}>
      <OutageMessageBanner heading={heading} />
    </Conditional>
  );
};
export default ManualApprovalMessage;
